import util from "../util/util";
export default class GiftCardService {
  addGiftCardRecord(payload) {
    return util
      .sendApiRequest("/giftcard", "POST", true, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }
  listAllGiftCard(data, start, length) {
    const activity = Object.keys(data).reduce((object, key) => {
      if (data[key] !== "") {
        object[key] = data[key];
      }
      return object;
    }, {});

    return util
      .sendApiRequest(
        // "/giftcard/list/" + start + "/" + length,
        "/giftcard/list",
        "POST",
        true,
        activity
      )
      .then(
        (response) => {
          return response;
        },
        (error) => {
          throw error;
        }
      );
  }
  getGiftCardDetails(dataId) {
    return util
      .sendApiRequest("/giftcard/" + dataId, "GET", true)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }
  editGiftCardRecord(payload) {
    return util.sendApiRequest("/giftcard", "PUT", true, payload).then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  }
  deleteGiftCardRecord(dataId) {
    return util
      .sendApiRequest("/giftcard/" + dataId, "DELETE", true)
      .then(
        (response) => {
          return response;
        },
        (error) => {
          throw new Error(error);
        }
      );
  }
  listCount(condition){
    return util
    .sendApiRequest("/giftCard/giftCardCount", "POST", condition)
    .then((response)=>{
      return response;
    })
    .catch((err)=>{
      throw err;
    })
  }
}
